import { Link } from "react-router-dom";

interface CtaBandProps {
  title?: string;
  description?: string;
}

export default function CtaBand({
  title = "有项目想聊聊？我们随时都在",
  description = "无论是影视制作、节目策划还是内容发行，芒果传媒都期待与你一起，把想法变成作品。",
}: CtaBandProps) {
  return (
    <section className="relative overflow-hidden bg-foreground-950">
      <div className="container-site py-14 md:py-20 relative z-10 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
        <div className="max-w-2xl">
          <h2 className="font-heading font-extrabold text-2xl md:text-4xl text-background-50 leading-tight">
            {title}
          </h2>
          <p className="text-background-200 mt-3 text-sm md:text-base leading-relaxed">{description}</p>
        </div>
        <div className="flex flex-col sm:flex-row gap-3 shrink-0">
          <Link
            to="/contact"
            className="px-6 py-3 rounded-md bg-primary-500 text-foreground-950 font-semibold hover:bg-primary-600 transition-colors text-center whitespace-nowrap cursor-pointer"
          >
            联系我们
          </Link>
          <Link
            to="/works"
            className="px-6 py-3 rounded-md border border-background-200/50 text-background-50 font-semibold hover:bg-background-50/10 transition-colors text-center whitespace-nowrap cursor-pointer"
          >
            查看作品案例
          </Link>
        </div>
      </div>
      <div className="absolute -right-10 -top-10 w-64 h-64 rounded-full bg-primary-500/20 blur-3xl"></div>
      <div className="absolute -left-10 -bottom-16 w-72 h-72 rounded-full bg-accent-500/20 blur-3xl"></div>
    </section>
  );
}